// extracted by mini-css-extract-plugin
export default {"logo":"styles_logo__Xz0Kb","header":"styles_header__kTPzH"};